import './App.css';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Home';
import Result from "./Result";


function App() {
  return (
    <div className="App bg-cyan-100 font-mono">
      <BrowserRouter>
        <Routes>
          <Route path={`/`} element={<Home />} />
          <Route path={`/result/`} element={<Result />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
